<template>
  <donations-container>
    <template #content>
      <div class="new-donation-modal__top-container" :style="`--bg-color:var(--${theme})`">
        <slot name="user-info"></slot>
        <slot name="details"></slot>
      </div>
    </template>
    <template #button>
      <slot name="button"></slot>
    </template>
  </donations-container>
</template>

<script>
import DonationsContainer from "./donations-container";

export default {
    name: "donation-pre-checkout",
    components: {DonationsContainer},
    props: {
        theme: {
            type: String,
            default: '--dark_blue_gradient',
        },

    },
};
</script>

<style scoped lang="scss">
.new-donation-modal {
  &__top-container {
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 711px;
    background: var(--bg-color);
    border-radius: 12px;
    margin: 15px;
  }
}

@media screen and (max-width: 768px) {
  .new-donation-modal {
    &__top-container {
      padding-top: 20px;
      padding-left: 10px;
      padding-right: 10px;
    }
  }
}
</style>